<template>
  <dtunes-modal @openModal="dialog = true" @closeModal="dialog = false">
    <template v-slot:button>
      <v-icon>mdi-square-edit-outline</v-icon>

    </template>
    <template v-slot:content>
      <v-card class="pad-10">
        <v-card-title class="d-flex justify-center">
          <p class="text-center">{{ coin.coinName }}</p>
        </v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-row>
              <v-col cols="12" sm="12">
                <label for="">Confirm Charge</label>
                <v-text-field color="auto" v-model="coin.postChargeAmount" type="number" outlined></v-text-field>
              </v-col>

            </v-row>
            <label for="">Confirm Charge Percentage</label>
            <v-text-field color="auto" v-model="coin.postChargePercentage" type="number" min="0" max="100"
              outlined></v-text-field>
            <default-button @click="updateCoinDetails" :loading="loading" :disabled="!isComplete">Save
              Edit</default-button>
          </v-form>
        </v-card-text>
      </v-card>
    </template>
  </dtunes-modal>
</template>

<script>
// ============= IMPORT COMPONENT ===========
import DtunesModal from "@/components/dtunes-modal.vue";
import DefaultButton from "@/components/Buttons/default-button.vue"

// =========== IMPORT SERVICES =============
import { PermissionService, CryptoService } from "@/services";
import app from '@/main'

export default {
  components: {
    DtunesModal,
    DefaultButton
  },
  props: {
    coin: Object
  },
  data: () => ({
    email: "",
    phonenumber: "",
    Permissions: [],
    isComplete: true,
    loading: false,
  }),
  mounted() {
    // this.getPermissions();
  },
  methods: {
    async updateCoinDetails() {

      let uploadCoin = {};
      this.loading = true;
      uploadCoin.id = this.coin.id;
      uploadCoin.postChargeAmount = this.coin.postChargeAmount || 0;
      uploadCoin.postChargePercentage = this.coin.postChargePercentage || 0;
      let data = await CryptoService.updateCoin(uploadCoin);

      if (data) {
        this.loading = false;
        this.$emit('closeModal');
        app.$store.dispatch('toast', {
          message: 'confirmation change successful',
          variant: 'success'
        })
        //alert('success');
      }
    },

    async getPermissions() {
      const data = await PermissionService.getPermissions();
      this.Permissions = data;
    },
  },
};
</script>